export const TestTextToAudioOutputGeneratedToken = {
    id: "sampleidhere"
};

export const TestTextToAudioOutput = {
    id: "sampletesttexttoaudiooutputidhere",
    inputs: [
        { src: 'a chill song with influences from lofi, chillstep and downtempo' },
    ],
    completed_at: "2023-06-03T18:17:14.513854Z",
    results: { 
        'duration': "9.216154124s", 
        'duration_for_inference': "9.193807904s", 
        'responses': [
            {
                'features': [
                    {
                        title: "text-to-audio-output.flac",
                        src: "https://xlab1.netlify.app/text-to-audio-output.flac",
                        type: 'AUDIO'
                    }
                ], 
                'id': "sampletesttexttoaudiooutputresponseidhere"
            }
        ]
    }
}